import apolloClient from 'app/domains/apollo';
import { InsightsMetadataPropertiesFragmentDoc, } from './InsightsMetadataProperties.gql';
import { searchFieldLabels } from './searchFieldLabels';
/**
 * The metadata-service property name mapped to the name the search API uses for the same field.
 */
export const dmsToSearchField = (name) => `metadataDocument${name}`;
let cachedProperties;
let cachedByField = new Map();
function getPropertiesByField() {
    let properties = [];
    try {
        const data = apolloClient.readFragment({
            id: 'ROOT_QUERY',
            fragment: InsightsMetadataPropertiesFragmentDoc,
            fragmentName: 'InsightsMetadataProperties',
        });
        properties = (data === null || data === void 0 ? void 0 : data.documentMetadataProperties) || [];
    }
    catch (_a) {
        properties = [];
    }
    if (properties !== cachedProperties) {
        cachedProperties = properties;
        cachedByField = new Map(properties.map((property) => [dmsToSearchField(property.name), property]));
    }
    return cachedByField;
}
export function getMetadataProperties() {
    return [...getPropertiesByField().values()];
}
/**
 * The metadata property a search field refers to, or undefined for search fields that
 * are not metadata properties and for properties this company has not defined.
 */
export function getMetadataProperty(field) {
    if (!field) {
        return undefined;
    }
    return getPropertiesByField().get(field);
}
/**
 * The display label for a search field. Resolves company-defined custom properties by
 * the name their company gave them, and system properties by their translated label.
 */
export function getFieldLabel(field) {
    var _a;
    if (!field) {
        return '';
    }
    return ((_a = getMetadataProperty(field)) === null || _a === void 0 ? void 0 : _a.label) || searchFieldLabels()[field] || field;
}
export function isKnownSearchField(field) {
    if (!field) {
        return false;
    }
    return Boolean(getMetadataProperty(field)) || field in searchFieldLabels();
}
